import { allpeepNoPayloadEndpoint } from "./helpers.js";
export const search = (rawClient) => ({
    posts: allpeepNoPayloadEndpoint(rawClient, '/search/posts'),
    profiles: allpeepNoPayloadEndpoint(rawClient, '/search/profiles'),
    events: allpeepNoPayloadEndpoint(rawClient, '/search/events'),
    jams: allpeepNoPayloadEndpoint(rawClient, '/search/jams'),
    groups: allpeepNoPayloadEndpoint(rawClient, '/search/groups'),
    counts: allpeepNoPayloadEndpoint(rawClient, '/search/counts'),
});
